var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactsImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.35 454.74",
    id: "no-messages",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M382.26 81.52h78.73v55.44h-78.73z",
    transform: "rotate(-164.89 421.63 109.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.51,
    cy: 147.56,
    r: 35.21,
    fill: "#c1e3f7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46534",
    d: "M231.92 211.64h26.22v242.7h-26.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M318.93 229.34h-174v-70.22a31.62 31.62 0 0 1 31.62-31.62h110.77a31.62 31.62 0 0 1 31.61 31.62v70.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#f46534",
    strokeMiterlimit: 10,
    d: "M208.14 229.34h-63.22v-70.22a31.62 31.62 0 0 1 31.61-31.62 31.62 31.62 0 0 1 31.61 31.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.59,
    height: 48.59,
    x: 277.36,
    y: 276.26,
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 5.52,
    transform: "rotate(45 301.654 300.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.06,
    height: 98.1,
    x: 27.42,
    y: 26.9,
    fill: "#c1e3f7",
    rx: 13,
    transform: "rotate(45 75.95 75.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 114.32,
    height: 114.32,
    x: 18.79,
    y: 18.79,
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 13,
    transform: "rotate(45 75.95 75.95)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M67.26 269.6a79 79 0 0 1 1.2 7.88c.31 2.64.49 5.28.65 7.92s.23 5.29.21 7.94a79.15 79.15 0 0 1-.35 8 79.63 79.63 0 0 1-1.21-7.89c-.3-2.64-.48-5.28-.64-7.92s-.23-5.29-.21-7.94.09-5.33.35-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M84 284.6a76.15 76.15 0 0 1-7.88 1.2c-2.64.31-5.28.49-7.92.65s-5.29.23-7.94.21a79.15 79.15 0 0 1-8-.35 79.63 79.63 0 0 1 7.89-1.21c2.64-.3 5.28-.48 7.92-.64s5.29-.22 7.94-.21 5.3.08 7.99.35ZM48.23 302.85a37.7 37.7 0 0 1 1.07 5.3c.24 1.77.41 3.54.51 5.32s.11 3.57.07 5.35a36.63 36.63 0 0 1-.5 5.39 36.56 36.56 0 0 1-1.06-5.3 63.622 63.622 0 0 1-.57-10.68 37.73 37.73 0 0 1 .48-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M59.49 313a38 38 0 0 1-5.3 1.07c-1.77.24-3.55.41-5.33.51s-3.56.11-5.35.06a36.35 36.35 0 0 1-5.38-.49 36.56 36.56 0 0 1 5.3-1.06c1.77-.25 3.55-.42 5.33-.51s3.56-.12 5.35-.07a36.47 36.47 0 0 1 5.38.49ZM311.84 56.13a47.47 47.47 0 0 1-6.1 1.06c-2 .24-4.09.41-6.13.51s-4.1.11-6.16.06a49.49 49.49 0 0 1-6.17-.5 47.47 47.47 0 0 1 6.1-1.06c2-.24 4.09-.41 6.13-.5s4.1-.11 6.16-.06a47.63 47.63 0 0 1 6.17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M300.12 69a47.62 47.62 0 0 1-1.06-6.11q-.36-3.06-.5-6.13c-.1-2.05-.11-4.1-.06-6.15a48 48 0 0 1 .5-6.18 47.93 47.93 0 0 1 1.06 6.11q.36 3.06.5 6.13t.06 6.15a49.65 49.65 0 0 1-.5 6.18ZM320.68 66.23a36.54 36.54 0 0 1 1.09 5.29c.25 1.77.44 3.55.54 5.33s.14 3.56.1 5.35a36.29 36.29 0 0 1-.46 5.38 37.67 37.67 0 0 1-1.1-5.29c-.25-1.77-.43-3.54-.53-5.32s-.14-3.57-.1-5.35a36.54 36.54 0 0 1 .46-5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M332 76.27a36.54 36.54 0 0 1-5.29 1.09c-1.77.26-3.55.44-5.33.54s-3.56.14-5.35.1a36.41 36.41 0 0 1-5.38-.46 36.27 36.27 0 0 1 5.29-1.09c1.77-.25 3.55-.44 5.32-.54s3.57-.14 5.36-.1a36.41 36.41 0 0 1 5.38.46ZM415.26 276.6a47.93 47.93 0 0 1-6.11 1.06q-3.06.36-6.13.5t-6.15.07a49.8 49.8 0 0 1-6.18-.5 47.93 47.93 0 0 1 6.11-1.06q3.06-.36 6.13-.5c2.05-.1 4.1-.11 6.15-.06a47.79 47.79 0 0 1 6.18.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M403.54 289.45a47.93 47.93 0 0 1-1.06-6.11q-.36-3.06-.5-6.13t-.06-6.15a47.79 47.79 0 0 1 .49-6.18 47.93 47.93 0 0 1 1.06 6.11c.24 2 .42 4.08.5 6.13s.12 4.1.06 6.15a47.79 47.79 0 0 1-.49 6.18ZM424.09 286.7a37.67 37.67 0 0 1 1.1 5.29c.25 1.77.43 3.55.54 5.33s.14 3.56.1 5.35a36.41 36.41 0 0 1-.46 5.38 36.3 36.3 0 0 1-1.1-5.29c-.25-1.77-.44-3.55-.54-5.33s-.13-3.56-.09-5.35a37.79 37.79 0 0 1 .45-5.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0850ec",
    d: "M435.41 296.74a36.67 36.67 0 0 1-5.3 1.09c-1.77.25-3.54.44-5.32.54s-3.56.14-5.35.1a36.29 36.29 0 0 1-5.38-.46 36.27 36.27 0 0 1 5.29-1.09c1.77-.26 3.54-.44 5.32-.54s3.56-.14 5.35-.1a36.54 36.54 0 0 1 5.39.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46534",
    d: "M144.92 229.34h63.22v70.22a31.62 31.62 0 0 1-31.61 31.62 31.62 31.62 0 0 1-31.61-31.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M199.4 272.81c-.28 3.51-.65 7-1 10.51v-.06c.13 2.22.2 4.43.29 6.65l.19 6.64a.19.19 0 0 1 0 .08c-.44 3.21-.9 6.41-1.42 9.6s-1 6.39-1.65 9.57c.25-3.23.58-6.45.94-9.67s.74-6.42 1.16-9.63v.08l-.17-6.65c0-2.21-.09-4.43-.08-6.65v-.06c.5-3.47 1.07-6.95 1.74-10.41ZM182.68 253.35c-1 9.23-2.18 18.45-3.34 27.67v-.21c1.17 2.18 2.27 4.41 3.4 6.62s2.26 4.42 3.34 6.66a.42.42 0 0 1 0 .29c-.83 4.31-1.6 8.64-2.49 12.94s-1.76 8.6-2.73 12.89q.93-6.53 2-13c.68-4.34 1.5-8.66 2.24-13l.05.3c-1.14-2.21-2.21-4.45-3.31-6.68s-2.2-4.44-3.24-6.7a.39.39 0 0 1 0-.21c1.31-9.2 2.64-18.39 4.08-27.57ZM236.74 320.22c.24 8.18.34 16.36.42 24.54l.06 12.27v12.27-.12l2 7.43 1.91 7.44a.22.22 0 0 1 0 .08l-.13 8.56-.21 8.56-.21-8.56-.13-8.56v.09l-2.08-7.4-2-7.41a.5.5 0 0 1 0-.12c0-4.09-.05-8.18 0-12.27l.06-12.27c-.03-8.17.06-16.35.31-24.53ZM172.84 242.6c-.91 8.14-2 16.25-3 24.36l-1.67 12.16c-.54 4.06-1.15 8.1-1.73 12.15v-.12l.9 7.63.86 7.63v.08l-1.34 8.51-1.41 8.45 1-8.51 1.07-8.49v.09l-1-7.62-1-7.62a.48.48 0 0 1 0-.12c.56-4.05 1.09-8.11 1.7-12.15l1.78-12.19c1.21-8.08 2.45-16.17 3.84-24.24ZM238.73 237.46c.21 4.38.31 8.75.39 13.13s.07 8.75.11 13.13 0 8.75-.11 13.12l-.14 6.57c-.08 2.18-.13 4.37-.25 6.56-.11-2.19-.16-4.38-.24-6.56l-.14-6.57c-.08-4.37-.08-8.75-.12-13.12s0-8.75.12-13.13.18-8.75.38-13.13ZM156.42 274.84c0 2.21-.17 4.41-.33 6.61s-.37 4.39-.59 6.58-.5 4.38-.82 6.56l-.5 3.27c-.2 1.09-.36 2.18-.59 3.26 0-1.11.07-2.21.11-3.31l.21-3.3c.15-2.2.37-4.39.6-6.58s.49-4.38.82-6.56.67-4.37 1.09-6.53ZM195.46 234.67c0 2.21-.17 4.41-.32 6.61s-.37 4.39-.6 6.58-.49 4.38-.82 6.56l-.49 3.27c-.2 1.08-.37 2.17-.6 3.25 0-1.1.07-2.2.11-3.31l.22-3.3c.14-2.2.37-4.39.59-6.58s.5-4.38.82-6.56.63-4.36 1.09-6.52ZM160.31 234.67c0 2.21-.17 4.41-.33 6.61s-.37 4.39-.59 6.58-.5 4.38-.83 6.56l-.49 3.27c-.2 1.08-.37 2.17-.6 3.25 0-1.1.08-2.2.11-3.31l.22-3.3c.15-2.2.37-4.39.59-6.58s.5-4.38.83-6.56.65-4.36 1.09-6.52ZM249.29 372.73c.21 6 .3 12.08.38 18.12s.08 12.08.12 18.12 0 12.08-.11 18.12l-.14 9.06c-.09 3-.13 6-.25 9.06-.11-3-.16-6-.24-9.06l-.14-9.06c-.08-6-.08-12.08-.12-18.12s0-12.08.12-18.12.18-12.08.38-18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f46534",
    d: "M249.58 81.16c-1.43-.49-2.86-1-4.28-1.42-.72-.22-1.43-.48-2.14-.66a7.67 7.67 0 0 0-2.14.07h-22.48v71.56a15.68 15.68 0 0 1-.12 2.65 3.22 3.22 0 0 0 .22 1.32l.43 1.33.86 2.65c1.19 3.53 2.47 7.06 4 10.59 1.5-3.53 2.78-7.06 4-10.59l.86-2.65.43-1.33a3.22 3.22 0 0 0 .22-1.32 15.68 15.68 0 0 1-.12-2.65V89.86H241a7.67 7.67 0 0 0 2.14.07c.71-.19 1.42-.44 2.14-.66 1.42-.44 2.85-.94 4.28-1.42 2.85-1 5.7-2.09 8.56-3.35a114.08 114.08 0 0 0-8.54-3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffedc5",
    d: "m350.82 93.08-12.06 44.69a37.51 37.51 0 0 1-1.39-4.55l10-36.94a34.1 34.1 0 0 1 3.45-3.2ZM342.31 102.75l-6.06 22.45a39.39 39.39 0 0 1 6.06-22.45ZM357.3 88.77l-15.11 56a35.32 35.32 0 0 1-1.75-3.18l13.77-51a28.23 28.23 0 0 1 3.09-1.82ZM363.52 86.12l-17.29 64a27 27 0 0 1-2-2.38l16.36-60.6a24.59 24.59 0 0 1 2.93-1.02ZM369.42 84.66 350.6 154.4a26.68 26.68 0 0 1-2.1-1.9l18.16-67.28a3.69 3.69 0 0 1 .39-.1c.78-.18 1.58-.33 2.37-.46ZM374.94 84.14l-19.84 73.48c-.76-.46-1.49-1-2.21-1.48l19.4-71.85a23.54 23.54 0 0 1 2.65-.15ZM380.2 84.34l-20.44 75.74c-.8-.35-1.56-.71-2.31-1.12l20.19-74.79a21.58 21.58 0 0 1 2.56.17ZM385.46 85.26l-20.7 76.67a21.66 21.66 0 0 1-2.39-.81L383 84.73c.82.14 1.66.27 2.46.53ZM390.55 86.9 370 163.1c-.83-.12-1.65-.26-2.49-.46L388.17 86a21 21 0 0 1 2.38.9ZM395.5 89.25l-20.06 74.31c-.86 0-1.74-.06-2.58-.13L393.22 88c.78.42 1.53.81 2.28 1.25ZM400.17 92.34 381 163.21a22.12 22.12 0 0 1-2.68.27L398 90.78a23.57 23.57 0 0 1 2.17 1.56ZM404.62 96.33 386.89 162c-.68.21-1.36.39-2 .55a7 7 0 0 1-.77.16l18.47-68.4a28 28 0 0 1 2.03 2.02ZM408.66 101.28l-15.8 58.5a26.13 26.13 0 0 1-2.94 1.24l16.82-62.32a23.33 23.33 0 0 1 1.92 2.58ZM412.25 107.68l-13.06 48.38a29 29 0 0 1-3.16 2.05l14.53-53.84a32.75 32.75 0 0 1 1.69 3.41ZM415.15 117.25l-8.62 31.92a31.7 31.7 0 0 1-3.65 3.87l11.05-40.95c.28.91.54 1.87.75 2.82.18.78.32 1.57.47 2.34ZM411.41 141.7l4.22-15.61a39.14 39.14 0 0 1-4.22 15.61Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.7,
    cy: 419.57,
    fill: "none",
    stroke: "#ffcd52",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M405.58 434.57c2.8-6.47.69-10.43.69-15 0-9.63-3.23-20.53-9-27.37a52.77 52.77 0 0 0-2.45 15.13c.03 9.67 5.02 20.4 10.76 27.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.98,
    cy: 407.4,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M370.66 420.64c0 3.81-1.54 6.85.56 12 9-7.22 15.84-19.32 15.84-31.79a55.56 55.56 0 0 0-1.91-13c-9.04 7.15-14.49 20.32-14.49 32.79Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.86,
    cy: 398.89,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M388.7 453.67v-51.14M388.7 422.56l-7.97-9.11M388.7 433.44l-11.49-13.13M388.7 444.65l-11.86-13.56M388.7 422.58l9.66-11.05M388.7 433.46l11.86-13.56M388.7 444.67l11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 363.86,
    cy: 398.89,
    fill: "none",
    stroke: "#008ef8",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M363.86 381.85v71.95M363.86 401.88l-9.64-11.03M363.86 412.76 352 399.2M363.86 423.97 352 410.41M363.86 401.9l9.67-11.05M363.86 412.78l11.86-13.56M363.86 423.99l11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 418.98,
    cy: 407.4,
    fill: "none",
    stroke: "#439916",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#439916",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M418.98 390.36V453.8M418.98 410.39l-9.65-11.03M418.98 421.27l-11.86-13.57M418.98 432.48l-11.86-13.56M418.98 410.41l9.66-11.05M418.98 421.29l11.86-13.56M418.98 432.5l11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 95.53,
    cy: 420,
    fill: "none",
    stroke: "#ffcd52",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M112.41 435c2.81-6.46.69-10.42.69-15 0-9.63-3.22-20.53-9-27.37a52.48 52.48 0 0 0-2.45 15.13c.04 9.63 5.02 20.4 10.76 27.24Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.81,
    cy: 407.83,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd52",
    d: "M77.5 421.07c0 3.81-1.55 6.85.56 12 9-7.21 15.83-19.32 15.83-31.79a55.47 55.47 0 0 0-1.9-13C83 395.43 77.5 408.6 77.5 421.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.7,
    cy: 399.32,
    fill: "#fff",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffcd52",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M95.53 454.1v-51.13M95.53 422.99l-7.97-9.11M95.53 433.87l-11.48-13.13M95.53 445.09l-11.86-13.57M95.53 423.02l9.67-11.06M95.53 433.89l11.86-13.56M95.53 445.11l11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.7,
    cy: 399.32,
    fill: "none",
    stroke: "#008ef8",
    strokeMiterlimit: 10,
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#008ef8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M70.7 382.29v71.95M70.7 402.31l-9.65-11.03M70.7 413.19l-11.86-13.56M70.7 424.4l-11.86-13.56M70.7 402.34l9.66-11.06M70.7 413.21l11.86-13.56M70.7 424.43l11.86-13.56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.81,
    cy: 407.83,
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    rx: 19.68,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ff5061",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M125.81 390.79v63.45M125.81 410.82l-9.64-11.03M125.81 421.7l-11.86-13.56M125.81 432.91l-11.86-13.56M125.81 410.84l9.67-11.05M125.81 421.72l11.86-13.56M125.81 432.93l11.86-13.56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a3a3a3",
    d: "M227 417.31h37.82a36.82 36.82 0 0 1 36.82 36.82H190.2a36.82 36.82 0 0 1 36.8-36.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7f7f7f",
    d: "M204.91 443.16a2 2 0 1 1-4.1 0c0-1.13 1.41-1.06 2.55-1.06s1.55-.1 1.55 1.06ZM224.59 431.33c0 2.14-2.23 2.88-4.37 2.88a3.88 3.88 0 1 1 0-7.75c2.14 0 4.37 2.73 4.37 4.87ZM258.47 431.79a3.88 3.88 0 0 1-3.88 3.88c-2.14 0-3.38-.75-3.38-2.89s1.24-4.87 3.38-4.87a3.88 3.88 0 0 1 3.88 3.88ZM294.53 445.5c0 2.15-2.23 2.89-4.37 2.89a3.88 3.88 0 0 1-3.88-3.88c0-2.14 2.23-2.88 4.37-2.88a3.87 3.87 0 0 1 3.88 3.87ZM238.59 446.63a3.88 3.88 0 0 1-3.87 3.88c-2.14 0-4.38-2.73-4.38-4.87a3.88 3.88 0 0 1 3.88-3.88c2.14 0 4.37 2.73 4.37 4.87ZM269.4 446.28c0 1.07-.87.86-1.94.86s-1.44.13-1.44-.94a1.94 1.94 0 0 1 1.94-1.94c1.04 0 1.44.95 1.44 2.02ZM279.2 426c0 1.07-.37 2.94-1.44 2.94a1.94 1.94 0 0 1-1.94-1.94c0-1.07.37-2.93 1.45-2.93a1.92 1.92 0 0 1 1.93 1.93ZM244.18 422.55c0 1.28-1.53 1.31-2.8 1.31a2.3 2.3 0 1 1 0-4.6c1.27 0 2.8 2.02 2.8 3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#545454",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.02 454.24h389.82"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsImage);
export default __webpack_public_path__ + "static/media/contactsImage.5cd6cc9077634476d1a4f481e71e208e.svg";
export { ForwardRef as ReactComponent };